import { ReactElement } from 'react';
import clsx from 'clsx';

interface TokenAssetAvatarProps {
  className?: string;
  height?: number;
  name: string;
  src: string;
  width?: number;
}

function TokenAssetAvatar({
  className,
  height = 4,
  name,
  src,
  width = 4,
}: TokenAssetAvatarProps): ReactElement {
  return (
    <img
      alt={name}
      className={clsx(
        `inline-block h-${height} w-${width} rounded-full ring-2 ring-white`,
        className
      )}
      src={src}
    />
  );
}

export default TokenAssetAvatar;
